/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ app: NonNullable<unknown> }} Directory_Detail_Scores_Platform_OwnedInputs */

const en_directory_detail_scores_platform_owned = /** @type {(inputs: Directory_Detail_Scores_Platform_OwnedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`AI Readiness and GEO Score are platform assessments generated by ${i?.app} after submission.`)
};

const zh_directory_detail_scores_platform_owned = /** @type {(inputs: Directory_Detail_Scores_Platform_OwnedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`AI 就绪度和 GEO Score 是 ${i?.app} 在提交后生成的平台评估。`)
};

/**
* | output |
* | --- |
* | "AI Readiness and GEO Score are platform assessments generated by {app} after submission." |
*
* @param {Directory_Detail_Scores_Platform_OwnedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_detail_scores_platform_owned = /** @type {((inputs: Directory_Detail_Scores_Platform_OwnedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Detail_Scores_Platform_OwnedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_detail_scores_platform_owned(inputs)
	return zh_directory_detail_scores_platform_owned(inputs)
});
export { directory_detail_scores_platform_owned as "directory.detail.scores_platform_owned" }